export default __webpack_public_path__ + "static/media/SecondTopEllipse.3c4a45dc.svg";